module.exports = __webpack_public_path__ + "static/img/NSW-37.fefa030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-37.jpg
// module id = uxAD
// module chunks = 0